import styled from 'styled-components'

import { MAX_MOBILE_WIDTH } from 'src/Styled/variables'

export const SignUpContainer = styled.div`
  height: 100vh;
  width: 100%;
  min-height: 100vh;
  display: flex;
  overflow-y: auto;
  background-color: ${({ theme }) => theme.unchangingColor.black};
  position: absolute;
`

export const InnerSignUpContainer = styled.div`
  margin: auto;
`

export const SignUpLogo = styled.div`
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const SignUpBlock = styled.div`
  margin: auto;
  border-radius: 8px;
  padding: 32px;
  max-width: 358px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  background-color: ${({ theme }) => theme.color.white};
  border: 1px solid ${({ theme }) => theme.color.lightGrey};
  @media screen and (min-width: ${MAX_MOBILE_WIDTH}) {
    padding: 32px;
    max-width: 600px;
  }
`

export const SignUpTitle = styled.div`
  font-family: 'Segoe UI';
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  color: ${({ theme }) => theme.color.darkGrey};
  text-align: center;
`

export const SignUpSubTitle = styled.div`
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  color: ${({ theme }) => theme.color.darkGrey};
  text-align: center;
`

export const SafetyBlock = styled.div`
  display: grid;
  grid-template-columns: 16px 1fr;
  gap: 8px;
  > svg {
    margin-top: 4px;
  }
`

export const InfoText = styled.div`
  font-family: 'Segoe UI';
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  color: ${({ theme }) => theme.color.darkGrey};
`

export const Condition = styled.div`
  text-align: center;
  font-family: 'Segoe UI';
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  color: ${({ theme }) => theme.color.darkGrey};

  & > a {
    cursor: pointer;
    color: ${({ theme }) => theme.color.darkGrey};
    text-decoration: none;
    border-bottom: 1px solid ${({ theme }) => theme.color.darkGrey};
  }
`

export const AlreadyHaveAccount = styled.div`
  text-align: center;
  font-family: 'Segoe UI';
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  color: ${({ theme }) => theme.color.darkGrey};

  a {
    color: ${({ theme }) => theme.color.brandGreen};
    text-decoration: none;
    border-bottom: 1px solid ${({ theme }) => theme.color.brandGreen};
  }
`
